import type { TextInputButtonSize } from "@stenajs-webui/elements";

import {
  FreightPortalPopover,
  type FreightPortalPopoverProps,
} from "../popover/FreightPortalPopover";
import { InformationMessageIcon } from "./InformationMessageIcon";
import type { InformationMessageType } from "./informationMessageUtils";

interface InformationMessageIconPopoverProps extends Omit<
  FreightPortalPopoverProps,
  "renderTrigger"
> {
  buttonSize?: TextInputButtonSize;
  iconType: InformationMessageType;
  tabIndex?: number;
}

export function InformationMessageIconPopover({
  buttonSize,
  iconType,
  tabIndex,
  ...props
}: InformationMessageIconPopoverProps) {
  return (
    <FreightPortalPopover
      {...props}
      renderTrigger={(triggerProps) => (
        <InformationMessageIcon
          size={buttonSize}
          type={iconType}
          tabIndex={tabIndex}
          {...triggerProps}
        />
      )}
    />
  );
}
